import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { VaccinationCardPetAddPage } from './vaccination-card-pet-add.page';
import { VaccinesService } from 'src/app/services/vaccines/vaccines.service';
import { VaccinationCardsService } from 'src/app/services/vaccination-cards/vaccination-cards.service';

const routes: Routes = [
  {
    path: '',
    component: VaccinationCardPetAddPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [VaccinationCardPetAddPage],
  providers: [
    VaccinesService,
    VaccinationCardsService
  ]
})
export class VaccinationCardPetAddPageModule {}
